// eslint-disable-next-line
import React from "react";
import {addEvent} from "../../../utils/functions";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

const moment = require("moment");

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _clsx = _interopRequireDefault(require("clsx"));

var _react = _interopRequireWildcard(require("react"));

var _EventRowMixin = _interopRequireDefault(require("./EventRowMixin"));
const userAccess = JSON.parse(localStorage.getItem('access'))
const access = userAccess && userAccess.events

var EventRow = /*#__PURE__*/function (_React$Component) {

    (0, _inherits2.default)(EventRow, _React$Component);

    var _super = (0, _createSuper2.default)(EventRow);

    function EventRow() {
        (0, _classCallCheck2.default)(this, EventRow);
        return _super.apply(this, arguments);
    }

    (0, _createClass2.default)(EventRow, [{
        key: "render",
        value: function render() {
            var _this = this;

            var _this$props = this.props,
                segments = _this$props.segments,
                slots = _this$props.slotMetrics.slots,
                className = _this$props.className;
            var lastEnd = 1;
            if (segments && segments.length > 0) {
                return /*#__PURE__*/_react.default.createElement("div", {
                    className: (0, _clsx.default)(className, 'rbc-row rbc-row-2'),
                    key: 'event-row' + segments.length + _this$props.slotMetrics.first
                }, segments.reduce(function (row, _ref, li) {
                    var left = _ref[0].left,
                        right = _ref[0].right,
                        span = _ref[0].span,
                        props = _this.props;
                    var key = '_lvl_' + li + '_' + moment(_this$props.slotMetrics.first);
                    var gap = left - lastEnd;

                    var content = []

                    if (gap) {
                        for (let j = lastEnd; j < left; j++) {
                            row.push(_EventRowMixin.default.renderSpan(slots, 1, "" + key + j + "_gap_start",
                                access ?
                                    /*#__PURE__*/_react.default.createElement("button", {
                                            className: "add-new-event 1", // IE10/11 need max-width. flex-basis doesn't respect box-sizing
                                            key: 'button_gap' + key,
                                            onClick: (e) => {
                                                addEvent(e, _this$props.slotMetrics.getDateForSlot(j - 1))
                                            }
                                            ,
                                        }, /*#__PURE__*/_react.default.createElement("i", {
                                            className: "fa-solid fa-plus" // IE10/11 need max-width. flex-basis doesn't respect box-sizing
                                            ,
                                        },)
                                    ) : ''));
                        }
                    }

                    _ref.forEach((event, i) => {
                        content[i] = _EventRowMixin.default.renderEvent({
                            ...props,
                            key: props.slotMetrics.first + '_event_' + event.event.id
                        }, event.event);
                    })
                    row.push(_EventRowMixin.default.renderSpan(slots, span, gap + key + 'add_new', [content,
                        access ?   /*#__PURE__*/_react.default.createElement("button", {
                                className: "add-new-event 2 " + gap + " " + left, // IE10/11 need max-width. flex-basis doesn't respect box-sizing
                                key: 'button_event_' + key,
                                onClick: (e) => {
                                    addEvent(e, _this$props.slotMetrics.getDateForSlot(left - 1))
                                }
                                ,
                            },/*#__PURE__*/_react.default.createElement("i", {
                                    className: "fa-solid fa-plus" // IE10/11 need max-width. flex-basis doesn't respect box-sizing
                                    ,
                                },
                            )
                        ) : '']));


                    if (7 - right && li + 1 === segments.length) {
                        for (let j = right; j < 7; j++) {
                            row.push(_EventRowMixin.default.renderSpan(slots, 1, key + j + "_gap_end", access ? /*#__PURE__*/_react.default.createElement("button", {
                                    className: "add-new-event 3", // IE10/11 need max-width. flex-basis doesn't respect box-sizing
                                    key: 'button_gap_end' + key,
                                    onClick: (e) => addEvent(e, _this$props.slotMetrics.getDateForSlot(j))
                                    ,
                                },/*#__PURE__*/_react.default.createElement("i", {
                                        key: 'i_gap_end' + key,
                                        className: "fa-solid fa-plus" // IE10/11 need max-width. flex-basis doesn't respect box-sizing
                                        ,
                                    },
                                )
                            ) : ''));
                        }
                    }
                    lastEnd = right + 1;
                    return row;
                }, []));
            } else {
                let row = [];
                for (let j = 1; j <= 7; j++) {
                    row.push(_EventRowMixin.default.renderSpan(slots, 1, j + "_gap_no", access ? /*#__PURE__*/_react.default.createElement("button", {
                            className: "add-new-event 4", // IE10/11 need max-width. flex-basis doesn't respect box-sizing
                            key: 'button_gap_no' + this.props.slotMetrics.first + j,
                            onClick: (e) => {
                                addEvent(e, _this$props.slotMetrics.getDateForSlot(j - 1))
                            }
                            ,
                        },/*#__PURE__*/_react.default.createElement("i", {
                                className: "fa-solid fa-plus" // IE10/11 need max-width. flex-basis doesn't respect box-sizing
                                ,
                            },
                        )
                    ) : ''));
                }
                return /*#__PURE__*/_react.default.createElement("div", {className: (0, _clsx.default)(className, 'rbc-row rbc-row-2')}, row)
            }

        }
    }]);
    return EventRow;
}(_react.default.Component);

EventRow.defaultProps = (0, _objectSpread2.default)({}, _EventRowMixin.default.defaultProps);
var _default = EventRow;
export default _default;